import {LoadingKeys} from '@/constants';
import {loadingStore} from './loading-store';

export const handleApiCallInStore = async (
  loadingKey: LoadingKeys,
  apiCall: () => void
) => {
  try {
    loadingStore.getState().setLoading(loadingKey, true);
    await apiCall();
  } catch (error) {
    return error;
  } finally {
    loadingStore.getState().setLoading(loadingKey, false);
  }
};

// update item in array of objects by id
export const updateItemById = (
  originalArray: any[],
  propertyName: string,
  propertyValue: any,
  id: string
) => {
  const newArray = originalArray.map(item => {
    if (item.objectID === id) {
      item[propertyName] = propertyValue;
    }
    return item;
  });
  return newArray;
};
export const getObjectIdsFromArrayOfObjects = arr => {
  if (arr.length > 0) {
    // eslint-disable-next-line array-callback-return
    return arr.map(arrItem => {
      if (arrItem.objectID) {
        return arrItem.objectID;
      }
    });
  }
  return undefined;
};
